var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-column list",on:{"click":_vm.handleClick}},[_c('div',{class:_vm.Icon,style:(_vm.ImageStyle)}),_c('div',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }